<template>
  <li
    class="nav-item"
    :class="{
      active: isActive,
      disabled: item.disabled,
      paid: item.paid || false,
    }"
  >
    <b-link v-bind="linkProps" class="d-flex align-items-center">
      <img
        class="mr-2"
        :src="
          require('@/assets/images/sidebar-icons/' +
            `${isActive ? item.icon + '-light' : item.icon}` +
            '.svg')
        "
        :alt="item.icon"
      />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge v-if="item.tag" pill :variant="item.tagVariant || 'primary'" class="mr-1 ml-auto">
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { BLink, BBadge } from 'bootstrap-vue'
import { useI18nUtils } from '@/libs/i18n/useI18nUtils'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,
      // i18n
      t,
    }
  },
}
</script>
